module.exports = __webpack_public_path__ + "static/marriot-MONEI-dde5bf9fba055baa34f3964367848cbf.png";